<template>
    <div class="app-container">
        <h2>{{ roles[role]["titre"] }}</h2>
        <el-button
            v-if="role == 'externe' "
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="handleCreate()"
        >
            Créer un Allocataire
        </el-button>
        <el-button
            v-if="role == 'externe' || role == 'allocataire'"
            type="primary"
            size="small"
            icon="el-icon-message"
            @click="dialogInviter = true"
        >
            Envoyer une invitation
        </el-button>
         <el-button
            v-if="role == 'allocataire'"
            type="primary"
            size="small"
            icon="el-icon-message"
            @click="dialogMessageAllAllocataires = true"
        >
            Message à tous les Allocataires confirmés
        </el-button>
       <el-table
            v-loading="loading"
            :data="list"
            border
            fit
            highlight-current-row
            style="width: 100%"
            @sort-change="sortchange"
        >
            <!--
            <el-table-column
                align="center"
                label="ID"
                width="80"
                prop="id"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            -->
            <el-table-column
                align="center"
                label="créé"
                width="120"
                prop="created_at"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.created_at | formatDate }}</span><br>
                    <span v-if="scope.row.notified_at" class="notifiedtable">notifié le {{ scope.row.notified_at | formatDate }}</span>
                    <!--
                    <router-link
                        v-if="!scope.row.roles.includes('admin')"
                        :to="$route.path + '/edit/' + scope.row.id"
                    >
                    -->
                    <router-link
                        :to="$route.path + '/edit/' + scope.row.id + '#profil'"
                    >
                        <el-button
                            type="success"
                            size="mini"
                            icon="el-icon-edit"
                        />
                    </router-link>
                    <el-button
                         v-if="role != 'bloqued' && role != 'admin'"
                        type="danger"
                        size="mini"
                        icon="el-icon-error"
                        @click="handleDelete(scope.row.id, scope.row.name)"
                    />
                    <el-button
                        v-if="role == 'allocataire' || role == 'admin'"
                        type="primary"
                        size="small"
                        icon="el-icon-message"
                        @click="opendialogNotification(scope.row)"
                    />
                </template>
            </el-table-column>

            <el-table-column
                align="center"
                label="Nom"
                prop="name"
                sortable="custom"
                class-name="searchinput"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span class="minitext">{{ scope.column.label }}</span>
                        <el-input
                            v-model="query.namefilter"
                            size="mini"
                            placeholder="Filtrer"
                            @input="getList"
                            clearable
                        />
                    </div>
                </template>
                <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Prénom"
                prop="prenom"
                sortable="custom"
                class-name="searchinput"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span class="minitext">{{ scope.column.label }}</span>
                        <el-input
                            v-model="query.prenomfilter"
                            size="mini"
                            placeholder="Filtrer"
                            @input="getList"
                            clearable
                        />
                    </div>
                </template>
                <template slot-scope="scope">
                    <span>{{ scope.row.prenom }}</span>
                </template>
            </el-table-column>

            <el-table-column
                align="center"
                label="Email"
                prop="email"
                sortable="custom"
                class-name="searchinput"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span class="minitext">{{ scope.column.label }}</span>
                        <el-input
                            v-model="query.emailfilter"
                            size="mini"
                            placeholder="Filtrer"
                            @input="getList"
                            clearable
                        />
                    </div>
                </template>
                <template slot-scope="scope">
                    <span>{{ scope.row.email }}</span><br>
                     <span v-if="scope.row.telfix"  class="adressetable">{{ scope.row.telfix }}</span>
                    <span v-else class="notifiedtable">sans tél.</span><br>
                   <span v-if="scope.row.livraison_adresse_label"  class="adressetable">{{ scope.row.livraison_adresse_label }}</span>
                    <span v-else class="notifiedtable">sans adresse</span><br>
                </template>
            </el-table-column>
            <el-table-column
                align="left"
                label="Commentaires"
                prop="comments"
                sortable="custom"
                class-name="searchinput"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span class="minitext">{{ scope.column.label }}</span>
                        <el-input
                            v-model="query.commentsfilter"
                            size="mini"
                            placeholder="Filtrer"
                            @input="getList"
                            clearable
                        />
                    </div>
                </template>
                <template slot-scope="scope">
                    <span  class="minitext" v-html="scope.row.commentsBr"></span>
                </template>
            </el-table-column>
        </el-table>
        <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="query.page"
            :limit.sync="query.limit"
            @pagination="getList"
        />
        <!-- CREATION -->
        <el-dialog title="Nouveau" :visible.sync="dialogFormVisible">
            <div v-loading="userCreating" class="form-container">
                <el-form
                    ref="userForm"
                    :model="newUser"
                    :rules="rules"
                    label-position="left"
                    label-width="150px"
                    style="max-width: 500px;"
                >
                    <el-form-item
                        label="Statut"
                        prop="role"
                    >
                        <el-select
                            v-model="newUser.role"
                            placeholder="Role"
                        >
                            <el-option
                                :key="'attente'"
                                :label="'en liste d’attente'"
                                :value="'externe'"
                            />
                            <!--
                            <el-option
                                :key="'allocataire'"
                                :label="'Allocataire confirmé'"
                                :value="'allocataire'"
                            />
                            -->
                       </el-select>

                    </el-form-item>
                    <el-form-item
                        label="Nom"
                        prop="name"
                        :error="getErrorForField('name', errors)"
                    >
                        <el-input v-model="newUser.name" />
                    </el-form-item>
                    <el-form-item
                        label="Prénom"
                        prop="prenom"
                        :error="getErrorForField('prenom', errors)"
                    >
                        <el-input v-model="newUser.prenom" />
                    </el-form-item>
                    <el-form-item
                        label="Email"
                        prop="email"
                        :error="getErrorForField('email', errors)"
                    >
                        <el-input v-model="newUser.email" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="createUser()">
                        Créer
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- DIALOG dialogMessageAllAllocataires -->
        <el-dialog
            title="MAIL ALLOCATAIRES"
            :visible.sync="dialogMessageAllAllocataires"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="inviterloading"
        >
            <div class="form-container">
                Envoyer un email à tous les allocataires confirmés<br />
                (les admins le recevront également)<br />
                (pour faire un test envoyé à vous même, écrivez "test" en sujet)<br />
                (pour faire un test envoyé aux admins, écrivez "test admins" en sujet)
                <hr />
                <el-form ref="MessageAllAllocatairesForm" style="max-width: 600px;">
                    <el-form-item label="Sujet" prop="sujet">
                        <el-input
                            type="text"
                            v-model="sujetAllAllocataires"
                        />
                    </el-form-item>
                    <el-form-item label="Message" prop="message">
                        <el-input
                            type="textarea"
                            :rows="10"
                            v-model="messageAllAllocataires"
                        />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogMessageAllAllocataires = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="sendMessageAllAllocataires()">
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- DIALOG INVITATION -->
        <el-dialog
            title="Inviter"
            :visible.sync="dialogInviter"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="inviterloading"
        >
            <div class="form-container">
                Envoyer un email proposant de s'inscrire.<br />
                message (modifiable dans Options):<br />
                <hr />
                <i>{{ options["mail_invitation"] }}</i>
                <hr />
                <el-form ref="invitationForm" style="max-width: 600px;">
                    <el-form-item label="nom" prop="nom">
                        <el-input v-model="invitationnom" />
                    </el-form-item>
                    <el-form-item label="e-mail" prop="email">
                        <el-input v-model="invitationmail" />
                    </el-form-item>
                    <el-form-item label="message (opt)" prop="message">
                        <el-input
                            type="textarea"
                            :rows="3"
                            v-model="invitationmessage"
                        />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogInviter = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="sendInvitation()">
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- DIALOG NOTIFICATION -->
        <el-dialog
            title="Notification"
            :visible.sync="dialogNotification"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="notificationLoading"
        >
            <div class="form-container">
                {{ dialogNotificationtitre }}
                <hr />
                <el-form ref="invitationForm" style="max-width: 600px;">
                    <el-form-item label="Message" prop="message">
                        <el-input type="textarea" :rows="8" v-model="messageNotification" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogNotification = false">
                        Annuler
                    </el-button>
                    <el-button
                        type="primary"
                        @click="handleNotifierUserAllocataire(notificationUser)"
                    >
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Resource from "@/api/resource";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import { findoptions } from "@/utils/options";
import { mapState } from "vuex";

const userResource = new Resource("users");

export default {
    name: "Users",
    components: { Pagination },
    props: {
        role: {
            type: String,
            default: "allocataire"
        }
    },
    computed: {
        ...mapState({
            id: state => state.user.id
        })
    },
    data() {
        return {
            rules: {
                name: {},
                prenom: {}
            },
            loading: false,
            list: null,
            total: 0,
            query: {
                page: 1,
                limit: 50,
                keyword: "",
                role: this.role,
                orderby: "id",
                orderbysens: "desc",
                namefilter: "",
                prenomfilter: "",
                emailfilter: "",
                commentsfilter: "",

            },
            dialogFormVisible: false,
            dialogInviter: false,
            dialogMessageAllAllocataires: false,
            messageAllAllocataires: "",
            sujetAllAllocataires: "",
            inviterloading: false,
            invitationmail: "",
            invitationmessage: "",
            invitationnom: "",
            dialogNotification: false,
            messageNotification: "",
            dialogNotificationtitre: false,
            notificationLoading: false,
            notificationUser: null,
            options: {
                mail_invitation: "",
                mail_notif_allocataire: ""
            },
            userCreating: false,
            newUser: {},
            errors: [],
            roles: {
                externe: {
                    titre: "En liste d'attente"
                },
                allocataire: {
                    titre: "Allocataires Confirmés"
                },
                admin: {
                    titre: "Administrateurs"
                },
                bloqued: {
                    titre: "Bloqués"
                }
            },
            updating: false
        };
    },
    created() {
        findoptions(this.options, this);
    },
    mounted() {},
    activated() {
        this.getList();
        this.newUser.role = this.role;
    },
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },

        handleCreate() {
            this.resetNewUser();
            this.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs["userForm"].clearValidate();
            });
        },
        sendInvitation() {
            console.log("sendInvitation");
            if (this.invitationmail) {
                this.inviterloading = true;
                userResource
                    .update(this.id, {
                        invitationmail: this.invitationmail,
                        invitationmessage: this.invitationmessage,
                        invitationnom: this.invitationnom
                    })
                    .then(response => {
                        console.log(response);
                        this.$message({
                            message:
                                "Le message a été envoyé à : " +
                                this.invitationnom +
                                " - " +
                                this.invitationmail,
                            type: "success",
                            duration: 5 * 1000
                        });
                        this.inviterloading = false;
                        this.dialogInviter = false;
                        this.invitationmail = "";
                        this.invitationmessage = "";
                        this.invitationnom = "";
                    })
                    .catch(error => {
                        console.log(error);
                        this.$message({
                            message: "Erreur lors de l’envoi",
                            type: "success",
                            duration: 5 * 1000
                        });
                        this.inviterloading = false;
                    });
            }
        },
        sendMessageAllAllocataires() {
            console.log("sendMessageAllAllocataires");
            if (this.messageAllAllocataires && this.sujetAllAllocataires) {
                this.inviterloading = true;
                userResource
                    .update(this.id, {
                        messageAllAllocataires: this.messageAllAllocataires,
                        sujetAllAllocataires: this.sujetAllAllocataires
                    })
                    .then(response => {
                        console.log(response);
                        let messageRetour = response['message'] ? response['message'] : '';
                        this.$message({
                            message:
                                messageRetour,
                            type: "success",
                            duration: 5 * 1000
                        });
                        this.inviterloading = false;
                        this.dialogMessageAllAllocataires = false;
                        this.messageAllAllocataires = "";
                        this.sujetAllAllocataires = "";
                    })
                    .catch(error => {
                        console.log(error);
                        this.$message({
                            message: "Erreur lors de l’envoi à tous les Allocataires",
                            type: "warning",
                            duration: 5 * 1000
                        });
                        this.inviterloading = false;
                    });
            } else{
                this.$message({
                    message: "Le message est vide",
                    type: "warning",
                    duration: 5 * 1000
                });
                this.inviterloading = false;

            }
        },
        opendialogNotification(user){
            this.dialogNotificationtitre = user.role === 'admin'
            ? "Voulez-vous envoyer un email à " + user.prenom + " " + user.name +
                " lui notifiant qu'il est Admin et l’invitant à initialiser son mot de passe?"
            : "Voulez-vous envoyer un email à " + user.prenom + " " + user.name +
                " lui notifiant qu'il est Allocataire et l’invitant à initialiser son mot de passe?";
            this.messageNotification = this.options["mail_notif_allocataire"].replace('<br>','\n');
            this.notificationUser = user;
            this.dialogNotification = true;
        },
        handleNotifierUserAllocataire(user) {
            this.errors = [];
            this.notificationLoading = true;
            // console.log(this.user);
            userResource
                .update(user.id, {
                    message: this.messageNotification,
                    notification: "externe2allocataire"
                })
                // .then(response => {
                .then(() => {
                    console.log("ok");
                    this.notificationLoading = false;
                    var notification = this.user.notification
                        ? " et notifié"
                        : "";
                    this.$message({
                        message: "Utilisateur mis à jour" + notification,
                        type: "success",
                        duration: 5 * 1000
                    });
                    this.dialogNotification = false;
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.errors = error.response.data.errors;
                    }
                    this.notificationLoading = false;
                    this.dialogNotification = false;
                });
        },
        createUser() {
            this.$refs["userForm"].validate(valid => {
                if (valid) {
                    // this.newUser.roles = [this.newUser.role];
                    this.userCreating = true;
                    userResource
                        .store(this.newUser)
                        .then(response => {
                            console.log(response);
                            this.$message({
                                message:
                                    "L’utilisateur " +
                                    this.newUser.name +
                                    "(" +
                                    this.newUser.email +
                                    ") a été créé.",
                                type: "success",
                                duration: 5 * 1000
                            });
                            this.resetNewUser();
                            this.dialogFormVisible = false;
                            this.handleFilter();
                            this.getList();
                        })
                        .catch(error => {
                            if (error.response && error.response.data) {
                                this.errors = error.response.data.errors;
                            }
                        })
                        .finally(() => {
                            this.userCreating = false;
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        },
        resetNewUser() {
            this.newUser = {
                name: "",
                prenom: "",
                email: "",
                role: this.role
            };
        },
        handleDelete(id, name) {
            this.$confirm(
                "Voulez-vous bloquer l’utilisateur " + name + "?",
                "Attention",
                {
                    confirmButtonText: "Bloquer",
                    cancelButtonText: "Anuler",
                    type: "warning"
                }
            )
                .then(() => {
                    userResource
                        .destroy(id)
                        .then(response => {
                            console.log(response);
                            this.$message({
                                type: "success",
                                message: "Allocataire bloqué"
                            });
                            this.handleFilter();
                            this.getList();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Anulée"
                    });
                });
        },
        handleFilter() {
            console.log("tape");
        },
        sortchange(ev) {
            console.log("sortchange");
            console.log(ev.prop + " " + ev.order);
            this.query.orderby = ev.prop;
            this.query.orderbysens = ev.order === "descending" ? "desc" : "asc";
            this.query.page = 1;
            this.getList();
        },
        async getList() {
            console.log("getList");
            const { limit, page } = this.query;
            this.loading = true;
            const { data, meta } = await userResource.list(this.query);
            this.list = data;
            this.list.forEach((element, index) => {
                element["index"] = (page - 1) * limit + index + 1;
            });
            this.total = meta.total;
            this.loading = false;
            console.log("getList");
            console.log(this.list);
        }
    }
};
</script>
